/**
 * Registers the ETHOS root service worker at app startup so offline Local Wisdom
 * works without ever enabling push. Registration alone does NOT request
 * notification permission and does NOT create a push subscription.
 */
export function registerRootServiceWorker() {
  if (typeof navigator === "undefined" || !("serviceWorker" in navigator)) return;
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw-push.js", { scope: "/" })
      .catch((err) => console.warn("Service worker registration failed:", err));
  });
}
